// ACTIONS
export const LOADER_TOGGLE = 'LOADER_TOGGLE'

// ACTION CREATORS
export function toggle (payload) {
  return {
    type: LOADER_TOGGLE,
    payload
  }
}
